import { Link } from 'react-router-dom';

export default function Logo() {
  return (
    <Link to="/" className="flex items-center cursor-pointer">
      <img
        src="https://static.readdy.ai/image/00f6adf0eb7e0374b271e1bcfa7140db/49a46457a0c7baf5e9d463ee7a99924b.png"
        alt="Goldsbvvn - Thị trường vàng"
        title="Goldsbvvn - Thị trường vàng"
        className="h-10 md:h-11 w-auto object-contain"
      />
    </Link>
  );
}